import { useNavigate } from "react-router-dom";
import { SharedHeader, SharedFooter, NAVY } from "../components/site/SharedLayout";

export default function NotFoundPage() {
  const navigate = useNavigate();

  return (
    <div style={{ fontFamily: "'Inter', 'Segoe UI', Arial, sans-serif", margin: 0, padding: 0 }}>
      <SharedHeader />

      <section
        style={{
          minHeight: "70vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          background: "#f5f7fb",
          padding: "80px 20px",
          textAlign: "center",
        }}
      >
        <div style={{ maxWidth: 520 }}>
          {/* 404 number */}
          <div
            style={{
              fontSize: 120,
              fontWeight: 900,
              color: NAVY,
              lineHeight: 1,
              opacity: 0.08,
              marginBottom: -40,
              userSelect: "none",
            }}
          >
            404
          </div>

          {/* Icon */}
          <div style={{ fontSize: 56, marginBottom: 20 }}>🔬</div>

          <h1
            style={{
              fontSize: 32,
              fontWeight: 700,
              color: NAVY,
              margin: "0 0 16px",
            }}
          >
            Page Not Found
          </h1>

          <p
            style={{
              color: "#556",
              fontSize: 16,
              lineHeight: 1.7,
              margin: "0 0 36px",
            }}
          >
            The page you're looking for doesn't exist or may have been moved.
          </p>

          <div style={{ display: "flex", gap: 14, justifyContent: "center", flexWrap: "wrap" }}>
            <button
              onClick={() => navigate("/")}
              style={{
                background: NAVY,
                color: "#fff",
                border: "none",
                borderRadius: 8,
                padding: "12px 28px",
                fontWeight: 700,
                fontSize: 14,
                cursor: "pointer",
              }}
            >
              Go to Home
            </button>

            <button
              onClick={() => navigate(-1)}
              style={{
                background: "transparent",
                color: NAVY,
                border: `2px solid ${NAVY}`,
                borderRadius: 8,
                padding: "12px 28px",
                fontWeight: 700,
                fontSize: 14,
                cursor: "pointer",
              }}
            >
              Go Back
            </button>
          </div>
        </div>
      </section>

      <SharedFooter />
    </div>
  );
}
